<template>
    <div class="mt-2  mb-3">
        <button type="button"
            class="btn btn-primary"
            v-if="canSelectIncidents"
            @click.prevent="showCreateEditor()">Select Incidents</button>
        <h2 class="mt-2 mb-2">Jobs</h2>
        <b-table :items="auditJobStore.items"
            :columns="columns"
            :value="auditJobStore.tableOptions"
            @optionChange="handleOptionChange">

            <template v-slot:cell.incidentNumber="{ item, column }">
                <span>{{ item.incidentNumber }}</span>
            </template>

            <template v-slot:cell.status="{ item, column }">
                <span>
                    {{item.status}}
                </span>

                <i class="bi bi-info-circle-fill text-info ms-2"
                    v-tooltip="item.comment"
                    v-if="item.comment"></i>
            </template>

            <template v-slot:cell.sampleSize="{ item, column }">
                <span v-if="item.sampleSize">{{ item.sampleSize }}</span>
                <span v-else>{{ item.percentUniverse }}%
                    <span v-if="item.percentUniverseMinCount&&item.percentUniverseMaxCount"> ({{item.percentUniverseMinCount}}-{{item.percentUniverseMaxCount}} incidents)</span>
                    <span v-else
                        if="item.percentUniverseMaxCount"> ({{item.percentUniverseMaxCount}} incidents max)</span>
                </span>
            </template>

            <template #cell.actions="{ item }">

                <button @click="deleteJobConfirm(item.id)"
                    type="button"
                    v-if="canDelete(item)"
                    class="btn btn-sm btn-danger">Delete

                </button>
                <span v-else></span>

            </template>
        </b-table>
    </div>
    <information-modal title="Delete"
        key="confirmDialog"
        ref="confirmDialog"
        :show-modal="isConfirmDialog"
        :show-footer="true"
        className="confirm"
        @dismiss="hideConfirmEditor">
        Are You Sure?
        <template v-slot:footer>
            <button type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal">No</button>

            <button type="button"
                class="btn btn-primary"
                @click.prevent="deleteJob">Yes</button>
        </template>
    </information-modal>
    <information-modal title="Select Incidents"
        :show-modal="isShowCreateEditor"
        ref="createDialog"
        @dismiss="hideCreateEditor">
        <form @submit.prevent="createJob">
            <fieldset class="border-bottom mb-3">
                <legend class="reset">Specify Incident Universe
                </legend>
                <div class="mb-3 row">
                    <label for="disabledTextInput"
                        class="col-form-label col-sm-3">Date Range:
                    </label>
                    <div class="col-sm-9">

                        <div class="col-form-label">
                            {{audit.startMonth}}&nbsp;to
                            {{audit.endMonth}}
                        </div>
                    </div>
                </div>
                <div class="mb-3">
                    <div class="row">

                        <label for="disabledTextInput"
                            class="form-label col-sm-3">Incident Types:
                        </label>
                        <div class="col-sm-9">
                            <div class="row">
                                <div class="col-3">

                                    <div class="form-check">
                                        <input class="form-check-input"
                                            type="checkbox"
                                            value="A"
                                            v-model="auditJob.incidentTypes"
                                            id="groupA">
                                        <label class="form-check-label"
                                            for="groupA">
                                            Group A
                                        </label>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="form-check">

                                        <input class="form-check-input"
                                            type="checkbox"
                                            value="B"
                                            v-model="auditJob.incidentTypes"
                                            id="groupB">
                                        <label class="form-check-label"
                                            for="groupB">
                                            Group B
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mb-3 mt-3 row">
                        <div class="col-sm-3">
                            <label for="offenseTypes"
                                class="col-form-label d-block">Offense(s):</label>
                            <small>Select one or more offenses, or leave blank for all</small>
                        </div>
                        <div class="col-sm-9">
                            <select id="offenseTypes"
                                v-model="auditJob.offenseTypes"
                                multiple
                                :disabled="auditJob.incidentTypes.length==0"
                                class="form-select">
                                <option v-for="item in offenseStore.items"
                                    :key="item.OffenseCode"
                                    :value="item.OffenseCode">
                                    {{item.OffenseLabel}}
                                </option>
                            </select>
                        </div>
                    </div>

                </div>

            </fieldset>

            <fieldset class="border-bottom mb-3">
                <legend class="reset">Random Selection from Universe
                </legend>
                <div class="container">
                    <div class="row mb-3 align-items-center">
                        <div class="col-md-3 form-check">
                            <input class="form-check-input"
                                type="radio"
                                name="measureType"
                                id="measureTypeNumber"
                                v-model="auditJob.measureType"
                                :value="0">
                            <label class="form-check-label"
                                for="measureTypeNumber">
                                Fixed count of incidents:
                            </label>
                        </div>
                        <div class="col-sm-4">
                            <text-input v-model="auditJob.sampleSize"
                                aria-label="Sample Size"
                                name="sampleSize"
                                type="number"
                                :disabled="auditJob.measureType!=0"
                                id="sampleSize"
                                class="form-control"
                                :error="errors.sampleSize"></text-input>
                        </div>
                    </div>
                    <div class="row mb-3 align-items-center">
                        <div class="col-md-3 form-check">
                            <div class="">
                                <input class="form-check-input"
                                    type="radio"
                                    name="measureType"
                                    v-model="auditJob.measureType"
                                    :value="1"
                                    id="measureTypePercent">
                                <label class="form-check-label"
                                    for="measureTypePercent">
                                    Percent of universe:
                                </label>
                            </div>

                        </div>
                        <div class="col-sm-4">
                            <div class="input-group">
                                <text-input v-model="auditJob.percentUniverse"
                                    aria-label="Percent of universe"
                                    name="percentUniverse"
                                    type="number"
                                    id="percentUniverse"
                                    class="form-control"
                                    :disabled="auditJob.measureType!=1"
                                    :error="errors.percentUniverse"></text-input>

                                <span class="input-group-text">%</span>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-sm-3 text-end">
                            <label for="percentUniverseMinCount"
                                class="col-form-label">Min Count:</label>
                        </div>
                        <div class="col-sm-4">

                            <text-input type="number"
                                v-model="auditJob.percentUniverseMinCount"
                                id="percentUniverseMinCount"
                                :disabled="auditJob.measureType!=1"
                                class="form-control"
                                :error="errors.percentUniverseMinCount"></text-input>

                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-sm-3 text-end">
                            <label for="percentUniverseMaxCount"
                                class="col-form-label">Max Count:</label>
                        </div>
                        <div class="col-sm-4">

                            <text-input type="number"
                                v-model="auditJob.percentUniverseMaxCount"
                                :disabled="auditJob.measureType!=1"
                                id="percentUniverseMaxCount"
                                class="form-control"
                                :error="errors.percentUniverseMaxCount"></text-input>

                        </div>
                    </div>

                </div>
            </fieldset>

            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button"
                    class="btn btn-secondary"
                    data-bs-dismiss="modal">Cancel</button>
                <button class="btn btn-primary"
                    type="submit">Save</button>
            </div>
        </form>
    </information-modal>
</template>
<script lang="ts" setup>
import BTable from "../BTable/BTable.vue";

import { BTableOptions, BTableColumn } from "../BTable/BTable.types";
import TextInput from "../Fields/TextInput.vue";
import InformationModal from "../Misc/InformationModal.vue";
import { computed, onMounted, reactive, ref, watch } from "vue";
import { useOffenseStore } from "@/stores/offenseStore";
import { useAuditJobStore } from "@/stores/auditJobStore";
import { AuditJobCreate, Audit } from "@/audit.types";
import { debounce } from "vue-debounce";
import { number, object } from "yup";
import { useFormValidation } from "../../validation";

var updateData = debounce(() => getData(), "15000ms");

const auditJob = ref<AuditJobCreate>({
    auditId: null,
    incidentTypes: [],
    offenseTypes: [],
    sampleSize: null,
    measureType: 0,
    percentUniverse: null,
    percentUniverseMinCount: null,
    percentUniverseMaxCount: null,
} as AuditJobCreate);

const schema = object<AuditJobCreate>({
    sampleSize: number()
        .nullable()
        .transform((value) => (isNaN(value) ? undefined : value))
        .when("measureType", {
            is: 0,
            then: (schema) => {
                return schema.required();
            },
        })
        .label("Sample Size"),
    percentUniverse: number()
        .nullable()
        .transform((value) => (isNaN(value) ? undefined : value))
        .when("measureType", {
            is: 1,
            then: (schema) => {
                return schema.required();
            },
        })
        .label("Percent of Universe"),
    percentUniverseMinCount: number()
        .nullable()
        .transform((value) => (isNaN(value) ? undefined : value))
        .label("Min Count"),
    percentUniverseMaxCount: number()
        .nullable()
        .transform((value) => (isNaN(value) ? undefined : value))
        .when("measureType", {
            is: 1,
            then: (schema) => {
                return schema.required();
            },
        })
        .when("percentUniverseMinCount", ([percentUniverseMinCount], schema) =>
            percentUniverseMinCount > 0
                ? schema.moreThan(auditJob.value.percentUniverseMinCount!)
                : schema
        )
        .label("Max Count"),
});

const date = ref();

watch(
    () => auditJob.value.incidentTypes,
    async (newQuestion, oldQuestion) => {
        await offenseStore.list(auditJob.value.incidentTypes.join(","));
    }
);

const auditJobStore = useAuditJobStore();
const offenseStore = useOffenseStore();
const selectedId = ref(0);

const confirmDialog = ref(null);
const props = defineProps<{
    id: number;
    audit: Audit;
    runAudits: boolean;
    createAudits: boolean;
}>();

const canSelectIncidents = computed(
    () => props.runAudits && props.audit.status != "Closed"
);
const canDelete = function (item) {
    return item.status == "Queued";
};

const columns = reactive<BTableColumn[]>([
    {
        key: "id",
        text: "Job #",
        sortable: true,
        value: (item) => item["id"],
    },
    {
        key: "status",
        text: "Status",
        sortable: true,
        value: (item) => item["status"],
    },
    {
        key: "incidentTypes",
        text: "Incident Groups",
        sortable: true,
        value: (item) => item["incidentTypes"],
    },
    {
        key: "offenseTypes",
        text: "Offense",
        sortable: true,
        value: (item) => item["offenseTypes"],
    },
    {
        key: "sampleSize",
        text: "Sample Size",
        sortable: true,
        value: (item) => item["sampleSize"],
    },
    {
        key: "incidentsCount",
        text: "Incidents Selected",
        sortable: true,
        value: (item) => item["incidentsCount"],
    },
    {
        key: "actions",
        text: "",
        sortable: true,
        value: (item) => 2,
    },
]);

const { handleSubmit, errors } = useFormValidation();

const createJob = async function () {
    if (await handleSubmit(schema, auditJob.value)) {
        auditJob.value.auditId = props.id;
        await auditJobStore.create(auditJob.value);
        hideCreateEditor();
        await getData();

        date.value = [];
        auditJob.value = {
            sampleSize: null,
            incidentTypes: [],
            offenseTypes: [],
            measureType: 0,
        } as unknown as AuditJobCreate;
    }
};

const isShowCreateEditor = ref(false);
const showCreateEditor = function () {
    date.value = "";
    isShowCreateEditor.value = true;
};
const hideCreateEditor = function () {
    isShowCreateEditor.value = false;
};

const runJob = async function (id: number) {
    await auditJobStore.run(id);
};

const handleOptionChange = function (options: BTableOptions) {
    if (options) {
        auditJobStore.tableOptions = options;
    }
};

const isConfirmDialog = ref(false);

const deleteJob = async function () {
    auditJobStore.deleteItem(selectedId.value);
    hideConfirmEditor();
    await getData();
};

const deleteJobConfirm = async function (id: number) {
    selectedId.value = id;
    isConfirmDialog.value = true;
};

const hideConfirmEditor = async function () {
    isConfirmDialog.value = false;
};

const getData = async function () {
    await auditJobStore.list(props.audit.id);
    await updateData();
};
onMounted(async () => {
    await getData();
});
</script>
<style scoped>
.reset {
    font-size: 1.1em;
    margin-bottom: 1.2em;
    font-weight: 600;
}
small {
    font-size: 0.775em;
}
</style>